
Shopify.queryParams = {};
var sortValue = "manual";

if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    sortValue = aKeyValue[1];
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

if (window.location.href.includes("account/addresses")) {
    window.location.replace("/account");
}

// Currency Setup

fx.base = "GBP";
fx.rates = {
    "GBP" : 1,
    "USD" : 1.32297,
    "EUR" : 1.09111,
    "JPY" : 137.405,
    "CAD" : 1.70300,  
    "AUD" : 1.76697	,
    "NZD" : 1.88096,
    "INR" : 98.4484,
    "CHF" : 1.18590,
    "AED" : 4.91366
}

// function checkCookie() {
//     var rates = getCookie("rates");
//     if (rates != "") {
      
//     } else {
//        if (rates != "" && rates != null) {
//          setCookie("rates", 1);
//        }
//     }
// }

// function setCookie(cname,exdays) {
//     var d = new Date();
//     d.setTime(d.getTime() + (exdays*24*60*60*1000));

//     var expires = "expires=" + d.toGMTString();
//     var cvalue = fx.rates;

//     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
// }
  
// function getCookie(cname) {
//     var name = cname + "=";
//     var decodedCookie = decodeURIComponent(document.cookie);
//     var ca = decodedCookie.split(';');
//     for(var i = 0; i < ca.length; i++) {
//         var c = ca[i];
//         while (c.charAt(0) == ' ') {
//         c = c.substring(1);
//         }
//         if (c.indexOf(name) == 0) {
//         return c.substring(name.length, c.length);
//         }
//     }
//     return "";
// }

function getRates() {

    console.log('Getting rates');

    // Load exchange rates data via AJAX:
    $.getJSON(
        'https://openexchangerates.org/api/latest.json?app_id=8ebc45d6a8694924b2bfa47699c89497',
        function(data) {
            // Check money.js has finished loading:
            if ( typeof fx !== "undefined" && fx.rates ) {
                fx.rates = data.rates;
                console.log("Rates updated");

                return fx.rates;
            } else {

            }
        }
    );
}

$(document).ready(function () {

//
//      To whoever will have to work on this code in the future
//
//      Forgive me
//
//          - Current Dev
//



    // Disable Alerts
    alert = function() {};

    var dropdownTime    = 400;
    var dropdownActive  = false;
    var totalPrice      = "";
    var selectedMenu    = localStorage.getItem('selectedMenu');
    var currentUrl      = window.location.href;
    var mobileMenuOpen  = false;
    var api_url         = "https://api.maisonmargauxltd.com/api.php";
    var customerOrders  = [];
    var cartQuantity    = 0;

    var cartMode        = "sales";
    var salesCart       = [];
    var rentCart        = [];

    var userCheckout    = false;
    var userRentals     = false;
    var userNotified    = false;

    var inRentals       = false;

    if (localStorage.getItem('userCheckout') == "true") {
        userCheckout = true;
    } else {
        userCheckout = false;
    }

    if (localStorage.getItem('userRentals') == "true") {
        userRentals = true;
    } else {
        userRentals = false;
    }

    if (localStorage.getItem('userNotified') == "true") {
        userNotified = true;
    } else {
        userNotified = false;
    }

    var globalCurrency = 'GBP';

    if (localStorage.getItem('globalCurrency')) {
        globalCurrency  = localStorage.getItem('globalCurrency');
        
        var selector    = $(".currency-select-dropdown").find("[value='" + globalCurrency + "']"); 
        var arrow       = $('#dropdown-arrow').clone();

        $('.selected-currency').html($(selector).html())
        arrow.appendTo('.selected-currency');

        getRates();
    } 

    setTimeout(() => {
        updateCart();
    }, 500);

    function clearAll() {
        rentCart = [];
        salesCart = [];
        Shopify.clear();

        localStorage.setItem('salesCart', JSON.stringify(salesCart));
        localStorage.setItem('rentCart', JSON.stringify(rentCart));
    }

    // clearAll();

    if (JSON.parse(localStorage.getItem('rentCart')) != null ) {

        if (JSON.parse(localStorage.getItem('rentCart')).length > 0 ) {
            rentCart = JSON.parse(localStorage.getItem('rentCart'));
            restoreCart("rentals");
        }        
    }

    if (JSON.parse(localStorage.getItem('salesCart')) != null ) {
        if (JSON.parse(localStorage.getItem('salesCart')).length > 0) {
            salesCart = JSON.parse(localStorage.getItem('salesCart'));
            restoreCart("sales");
        }
    }

    if (JSON.parse(localStorage.getItem('itemsArray')) != null ) {
        if (JSON.parse(localStorage.getItem('itemsArray')).length > 0) {
            itemsArray = JSON.parse(localStorage.getItem('itemsArray'));
            checkCartItems();
        }
    }

    // Rentals check

    if ($('#is-rentals').length) {
        $('.header-menu').css("display", "grid");
        $('.header-logo').css("display", "block");
        $('.header-links-user').css("display", "grid");


        $('.shop-site').css("display", "none");
    } else {
        $('.header-menu').css("display", "grid");
        $('.header-logo').css("display", "block");
        $('.header-links-user').css("display", "grid");

        $('.rent-site').css("display", "none");
    }

    $('.page-back').click(function (e) { 
        e.preventDefault();

        history.go(-1);
    });

    // SlideShow

    var imagesMain  = $('.main-slideshow').find('img');
    var counterMain = 0;

 
    setTimeout( function(){ 
        slideshowMain();
    }, 5000);


    function slideshowMain() {
            var elm = imagesMain[counterMain];
            var jelm = $(elm);
            jelm.fadeOut(2500);

            if (counterMain + 2 > imagesMain.length) {
                counterMain = -1;
            }

            var elm = imagesMain[counterMain + 1];
            var jelm = $(elm);
            jelm.fadeIn(2500);


            setTimeout( function(){ 
                counterMain++;
                slideshowMain();
            }, 4000);

    }

    var imagesLooks  = $('.looks-slideshow').find('img');
    var counterLooks = 0;

    if (window.matchMedia('(min-width: 780px)').matches) {
        console.log("true");
        setTimeout( function(){ 
            slideshowLooks(); 
        }, 5000);
    } else {
        console.log("false");
    }

    function slideshowLooks() {
            var elm = imagesLooks[counterLooks];
            var jelm = $(elm);
            jelm.fadeOut(2500);

            if (counterLooks + 2 > imagesLooks.length) {
                counterLooks = -1;
            }

            var elm = imagesLooks[counterLooks + 1];
            var jelm = $(elm);
            jelm.fadeIn(2500);


            setTimeout( function(){ 
                if (window.matchMedia('(min-width: 780px)').matches) {
                    counterLooks++;
                    slideshowLooks();
                }
            }, 4000);

    }

    $('#sort-by')
    .val(sortValue)
    .bind('change', function() {
        Shopify.queryParams.sort_by = jQuery(this).val();
        location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
    });

    // Dropdown

    $('body').on('click',function(event){
        if(!$(event.target).is('#dropdown-trigger')){
            $('.dropdown-select').find('.dropdown').slideUp(300);
            $('.dropdown-select').removeClass('active');
        }
     });

    if ($('.dropdown-select').length) {
        var text = $('#sort-by').find(":selected").text();

        $('.dropdown-select > p').text(text);
    }

    $('.dropdown-select').click(function (e) { 
        e.preventDefault();

        if ($(this).hasClass('active')) {
            $(this).find('.dropdown').slideUp(300);
            $(this).removeClass('active');
        } else {
            $(this).find('.dropdown').slideDown(300);
            $(this).addClass('active');
        }
    });

    $('.dropdown > p').click(function (e) { 
        e.preventDefault();
        
        console.log("drop-click");

        var value   = $(this).attr('data');
        var text    = $(this).text();

        $('#sort-by').val(value);
        $('#sort-by').trigger('change');
        $('.dropdown-select > p').text(text);

    });


    if (localStorage.getItem("cookieAccepted") != "true") {
        $(".cookie-banner").css("bottom", "0px");
    }

    if (localStorage.getItem("cartMode") == "rentals") {
        cartMode = "rentals";
    } else if (localStorage.getItem("cartMode") == "sales") {
        cartMode = "sales";
    }

    if (localStorage.getItem("rentItemsAdded") == "true") {
        var rentItemsAdded = "true"
    } else {
        var rentItemsAdded = "false"
    }

    if (localStorage.getItem("salesItemsAdded") == "true") {
        var salesItemsAdded = "true"
    } else {
        var salesItemsAdded = "false"
    }

    $('#accept-cookie').click(function (e) { 
        e.preventDefault();
        
        localStorage.setItem("cookieAccepted", "true");

        $(".cookie-banner").css("bottom", "-200px");
    });

    if ($('.how-to').length) {
        $('.contact-banner').css("width", "calc(100% - 20px)");
    }
    
    if (localStorage.getItem("selectedDateButton")) {
        let calendar = new VanillaCalendar({
            selector: "#myCalendar",
            pastDates: false,
            date: new Date(localStorage.getItem("selectedDateButton")),
            onSelect: (data, elem) => {
                var msec    = Date.parse(data.date);
                localStorage.setItem("selectedDateButton", data.date);
            }
        })
    
        let sideCalendar = new VanillaCalendar({
            selector: "#mySideCalendar",
            pastDates: false,
            date: new Date(localStorage.getItem("selectedDateButton")),
            onSelect: (data, elem) => {
                var msec    = Date.parse(data.date);
                localStorage.setItem("selectedDateButton", data.date);
            }
        })
    } else {
        let calendar = new VanillaCalendar({
            selector: "#myCalendar",
            pastDates: false,
            date: new Date(),
            onSelect: (data, elem) => {
                var msec    = Date.parse(data.date);
                localStorage.setItem("selectedDateButton", data.date);
            }
        })
    
        let sideCalendar = new VanillaCalendar({
            selector: "#mySideCalendar",
            pastDates: false,
            date: new Date(),
            onSelect: (data, elem) => {
                var msec    = Date.parse(data.date);
                localStorage.setItem("selectedDateButton", data.date);
            }
        })
    }

    if ($('.guide-gallery-mobile').length) {
        var slider = tns({
            container: '.guide-gallery-mobile',
            controlsContainer: '.guide-gallery-controls',
            controls: true,
            nav: false,
            autoWidth: true,
            center: true,
            items: 1,
            loop: true,
            slideBy: 1,
            autoplay: false
        });
    }
 
    if ($('.image-gallery-mobile').length) {
        var slider = tns({
            container: '.image-gallery-mobile',
            controlsContainer: '.guide-gallery-controls',
            controls: true,
            nav: false,
            autoWidth: true,
            center: true,
            items: 1,
            loop: true,
            slideBy: 1,
            autoplay: false
        });
    }


    if (selectedMenu && 
        selectedMenu < 6 && 
        currentUrl != document.location.origin + "/") {

        $('#menu-' + selectedMenu).addClass('menu-selected')
    }

    $('.menu-item').hover(function () {

        $(this).find('.menu-dropdown').dequeue().stop().slideDown(dropdownTime);
            
        }, function () {
            $(this).find('.menu-dropdown').slideUp(500);
        }
    );

    $('.menu-item').click(function () { 
        var id = $(this).attr('data-id');

        localStorage.setItem('selectedMenu', id);
    });

    // What a mess this is

    $('.hover-fade').hover(function () {

        if ($(this).has( ".second-image" ).length) {
            var secondImage = $(this).find('.second-image');
        }

        var img = $(this).find('img:first-of-type');

            if (secondImage) {
                img.css('opacity', '0');
                secondImage.css('opacity', '1');
            } else {
                img.css('opacity', '0.8');
                $(this).find('.img-holder').css('background-color', 'black');
            }
 
        }, function () {

            if ($(this).has( ".second-image" ).length) {
                var secondImage = $(this).find('.second-image');
            }

            var img = $(this).find('img:first-of-type');
            
            img.css('opacity', '1');

            if (secondImage) {
                secondImage.css('opacity', '0');
            } else {
                $(this).find('.img-holder').css('background-color', 'white');
            }
 
        }
    );

    // Mobile Menu 

    $('.hamburger').click(function (e) { 
        e.preventDefault();

        mobileMenuOpen = true;
        
        $('.header-menu-mobile').css('right', '0px');
        $('body, html').css('overflow', 'hidden');
    });

    $('.hamburger-side').click(function (e) { 
        e.preventDefault();

        if ($(this).hasClass('side-open')) {
            $(this).removeClass('side-open');
            $('.side-menu').css('right', '-500px');
            $('.side-menu-hider').css('display', 'none');
            $('body, html').css('overflow', 'auto');
        } else {
            $(this).addClass('side-open');
            $('.side-menu').css('right', '0px');
            $('.side-menu-hider').css('display', 'block');
            $('body, html').css('overflow', 'hidden');
        }
    });

    $('.side-menu-hider').click(function (e) { 
        e.preventDefault();
        
        $('.hamburger-side').removeClass('side-open');
        $('.side-menu').css('right', '-500px');
        $('.side-menu-hider').css('display', 'none');
        $('body, html').css('overflow', 'auto');
    });

    $('#mobile-menu-close').click(function (e) { 
        e.preventDefault();

        mobileMenuOpen = false;
        
        $('.header-menu-mobile').css('right', '-100vw');
        $('body, html').css('overflow-x', 'hidden');
        $('body, html').css('overflow-y', 'auto');
    });

    $('.mobile-menu-icon').click(function (e) { 
        e.preventDefault();

        var parent  = $(this).parent();
        var icon    = parent.find('.mobile-menu-icon');

        if ($(this).attr('clicked') == 'true') {
            parent.find('.mobile-menu-dropdown').slideUp(dropdownTime);
            parent.find('#menu-expand').fadeIn(dropdownTime);
            parent.find('#menu-close').fadeOut(dropdownTime);
    
            icon.attr('clicked', 'false');
        } else {
            parent.find('.mobile-menu-dropdown').slideDown(dropdownTime);
            parent.find('#menu-expand').fadeOut(dropdownTime);
            parent.find('#menu-close').fadeIn(dropdownTime);
    
            icon.attr('clicked', 'true');
        }
        
    });

    $('.sub-mobile-menu-icon').click(function (e) { 
        e.preventDefault();

        var parent  = $(this).parent();
        var icon    = parent.find('.sub-mobile-menu-icon');

        if ($(this).attr('clicked') == 'true') {
            parent.find('.sub-mobile-menu-dropdown').slideUp(dropdownTime);
            parent.find('#sub-menu-expand').fadeIn(dropdownTime);
            parent.find('#sub-menu-close').fadeOut(dropdownTime);
    
            icon.attr('clicked', 'false');
        } else {
            parent.find('.sub-mobile-menu-dropdown').slideDown(dropdownTime);
            parent.find('#sub-menu-expand').fadeOut(dropdownTime);
            parent.find('#sub-menu-close').fadeIn(dropdownTime);
    
            icon.attr('clicked', 'true');
        }
        
    });

    // Homepage Banner

    if ($('.image-banner').length) {
        var image   = $('.image-banner-img img');
        var margin  = $('.wrapper').css('margin-left');

        image.css('left', '-' + margin);

        $( window ).resize(function() {
            margin  = $('.wrapper').css('margin-left');
            image.css('left', '-' + margin);
        });
    }


    // Currency Change

    $('.selected-currency').click(function () {

        if ($(this).hasClass('dropdown-open')) {
            $('.currency-select-dropdown').dequeue().stop().slideUp(dropdownTime);
            $(this).removeClass('dropdown-open');

            $(this).css({
                "border": "none"
            });
        } else {

            getRates();

            $('.currency-select-dropdown').dequeue().stop().slideDown(dropdownTime);
            $(this).addClass('dropdown-open');

            $(this).css({
                "border-top": "0.5px solid #848588",
                "border-left": "0.5px solid #848588",
                "border-right": "0.5px solid #848588",
                "border-radius": "2px"
            });
        }
    });

    $('.currency-select-item').click(function (e) {
        e.preventDefault();
        
        globalCurrency = $(this).attr('value');
        localStorage.setItem("globalCurrency", globalCurrency);

        if ($('#price').length) {
            var priceHolder = $('#price');
            var price       = priceHolder.attr('data-original-price');
            var num         = parseInt($('#quantity').html());

            price = convertCurrency(price);
            priceHolder.text(price);

            updateProductTotal(num);
        } else if ($('#cart-product-price').length) {
            updateCart();
        }

        var arrow = $('#dropdown-arrow').clone();
        $('.selected-currency').html($(this).html())
        arrow.appendTo('.selected-currency');

        $('.currency-select-dropdown').dequeue().stop().slideUp(dropdownTime);
        $('.selected-currency').removeClass('dropdown-open');

        $('.selected-currency').css({
            "border": "none"
        });
    });

    if (globalCurrency != "" || globalCurrency != "GBP") {
        if ($('#price').length) {
            var priceHolder = $('#price');
            var totalHolder = $('#total');
            var price       = priceHolder.attr('data-original-price');

            price = convertCurrency(price);

            priceHolder.text(price);
            totalHolder.text(price);
        }
    }

    function convertCurrency(price, num) {
        if (price.includes("Dhs. ")) {
            price = price.replace('Dhs. ', '')
        } else if (price.includes("SFr. ")) {
            price = price.replace('SFr. ', '')
        }
        
        var priceInt        = accounting.unformat(price);

        if (num) {
            priceInt = priceInt * num;
        }

        var convertedPrice  = fx(priceInt).from("GBP").to(globalCurrency); 
        var formattedPrice  = accounting.formatMoney(convertedPrice, { symbol: globalCurrency,  format: "%v %s" });
        
        switch (globalCurrency) { 
            case 'USD':
                formattedPrice = "$" + formattedPrice;
                break;
            case 'GBP':
                formattedPrice = "£" + formattedPrice;
                break;

            case 'EUR':
                formattedPrice = "€" + formattedPrice;
                break;

            case 'CAD':
                formattedPrice = "$" + formattedPrice;
                break;

            case 'AUD':
                formattedPrice = "$" + formattedPrice;
                break;

            case 'INR':
                formattedPrice = "₹" + formattedPrice;
                break; 

            case 'JPY':
                formattedPrice = "¥" + formattedPrice;
                break;

            case 'NZD':
                formattedPrice = "$" + formattedPrice; 
                break;

            case 'CHF':
                formattedPrice = "" + formattedPrice;
                break;

            case 'AED':
                formattedPrice = "" + formattedPrice;
                break;
            default:
                formattedPrice = "£" + formattedPrice;
                break;
        }

        return formattedPrice;
    }

    // Product Page

    var swiper = new Swiper('.swiper-container', {
        cssMode: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // pagination: {
        //   el: '.swiper-pagination'
        // },
        mousewheel: false,
        keyboard: true,
        loop: true,
        speed: 300 
    });

    $('.slideshow-gallery-item').click(function (e) { 
        e.preventDefault();

        var slide = $(this).attr('data');
        
        $('.slideshow-fullscreen').fadeIn();
        swiper.update()
        swiper.slideTo(slide, 0)
        
    });

    $('.close-slideshow').click(function (e) { 
        e.preventDefault();
        
        $('.slideshow-fullscreen').fadeOut();
    });

    $('.dropdown-select-product').click(function (e) { 
        e.preventDefault();

        if ($(this).hasClass('active')) {
            $(this).find('.dropdown-product').slideUp(300);
            $(this).removeClass('active');
        } else {
            $(this).find('.dropdown-product').slideDown(300);
            $(this).addClass('active');
        }
    });

    $('.dropdown-product > p').click(function (e) { 
        e.preventDefault();

        if ($(this).hasClass('sold-out')) {
            return false;
        }

        var id              = $(this).attr('data');
        var variantId       = $('#' + id).attr('value');
        var variantPriceRaw = $('#' + id).attr('data-raw-price');
        var variantPrice    = $('#' + id).attr('data-original-price');
        var variantStock    = $('#' + id).attr('data-stock');
        var text            = $(this).text();

        $('#add-cart').attr('data-id', variantId);
        $('#ProductSelect-').val(variantId);

        $('#price').attr('data-raw-price', variantPriceRaw);
        $('#price').attr('data-original-price', variantPrice);
        $('#price').text(convertCurrency(variantPrice));

        $('#quantity').attr('data-stock', variantStock)

        var num = parseInt($('#quantity').html());

        if (num > variantStock) {
            num = variantStock;
            pad(num, 4, 1);
            updateProductTotal(num);
            updateProductQuantity(num);

            $('#quantity-alert').css("display", "none");
        }

        updateProductTotal(num);

        $('.dropdown-select-product > p').text(text);

    });

    $('#plus').click(function (e) { 
        e.preventDefault();
        var stock = $('#quantity').attr('data-stock');
        var available = $('#quantity').attr('data-available');
        var num = parseInt($('#quantity').html());

        if (available == "deny") {
            if (num < stock) {
                num = num + 1;
                pad(num, 4, 1);
                updateProductTotal(num);
                updateProductQuantity(num);

                $('#quantity-alert').css("display", "none");
            } else {
                $('#quantity-alert').css("display", "block");
            }
        } else {
            num = num + 1;
            pad(num, 4, 1);
            updateProductTotal(num);
            updateProductQuantity(num);
        }

    });

    $('#minus').click(function (e) { 
        e.preventDefault();

        var stock = $('#quantity').attr('data-stock');
        var available = $('#quantity').attr('data-available');
        var num = parseInt($('#quantity').html());
        

        if (num > 0) {
            if (available == "deny" && num <= stock) {
                $('#quantity-alert').css("display", "none");
                num = num - 1;
            } else {
                num = num - 1;
            }
        } 

        pad(num, 4, 1);
        updateProductTotal(num);
        updateProductQuantity(num);
    });

    $('#add-cart').click(function (e) { 
        e.preventDefault();
        
        var quantity    = $(this).attr('data-quantity');
        var id          = $(this).attr('data-id');
        var type        = $(this).attr('data-type');

        if (type == "shop") {
            cartMode = "sales"
        } else {
            cartMode = "rentals"
        }

        $('.empty-side-cart-alert').fadeOut(100);
        
        addToCart(id, quantity);
    });

    function pad(num, size, target) {
        var string  = "000" + num;
        string      = string.substr(string.length-size);

        switch (target) {
            case 1:
                $('#quantity').html(string);
                break;

            case 2:
                $('#quantity-people').html(string);
                break;
        
            default:
                break;
        }
    }

    function updateProductTotal(num) {
        var priceHolder = $('#price');
        var price       = priceHolder.text();

        if (price.includes("Dhs. ")) {
            price = price.replace('Dhs. ', '')
        } else if (price.includes("SFr. ")) {
            price = price.replace('SFr. ', '')
        }

        var priceInt = accounting.unformat(price);
        priceInt = priceInt * num;
        var formattedPrice  = accounting.formatMoney(priceInt, { symbol: globalCurrency,  format: "%v %s" });
        
        switch (globalCurrency) {
            case 'USD':
                formattedPrice = "$" + formattedPrice;
                break;
            case 'GBP':
                formattedPrice = "£" + formattedPrice;
                break;

            case 'EUR':
                formattedPrice = "€" + formattedPrice;
                break;

            case 'CAD':
                formattedPrice = "$" + formattedPrice;
                break;

            case 'AUD':
                formattedPrice = "$" + formattedPrice;
                break;

            case 'INR':
                formattedPrice = "₹" + formattedPrice;
                break;

            case 'JPY':
                formattedPrice = "¥" + formattedPrice;
                break;

            case 'NZD':
                formattedPrice = "$" + formattedPrice;
                break;

            case 'CHF':
                formattedPrice = "" + formattedPrice;
                break;

            case 'AED':
                formattedPrice = "" + formattedPrice;
                break;
            default:
                formattedPrice = "£" + formattedPrice;
                break;
        }

        $('#total').text(formattedPrice);
    }

    function updateProductQuantity(num) {
        var holder = $('#add-cart');
        var formQuantity = $('.product-form__input--quantity');
        formQuantity.val(num);
        holder.attr('data-quantity', num);
    }

    function addToCart(id, quantity) {
        // clearCart();
        
        Shopify.addItem(id, quantity, function() {
            $.when(updateCart()).then(openCart());
        });
        
    } 

    $('.remove-item').click(function (e) { 
        e.preventDefault();
        
        var parentID    = $(this).attr('data-parent');
        var itemID      = $(this).attr('data-variant-id');

        $('.' + parentID).fadeOut();

        if (parentID == "cart-item-sales-1") {
            salesItemsAdded = "false";
            localStorage.setItem("salesItemsAdded", "false")
            $('.empty-side-cart-alert').fadeIn();
            $('.empty-cart-alert').fadeIn();
            $('.cart-total').fadeOut();
            $('.cart-extra-info').fadeOut();
        }

        if (parentID == "cart-item-rental-1") {
            rentItemsAdded = "false";
            localStorage.setItem("rentItemsAdded", "false")
            $('.empty-side-cart-alert').fadeIn();
            $('.empty-cart-alert').fadeIn();
            $('.cart-total').fadeOut();
            $('.cart-extra-info').fadeOut();
        }

        removeItemFromCart(itemID)

    });

    function removeItemFromCart(id) {
        Shopify.removeItem(id);

        setTimeout(() => {
            Shopify.getCart(function(cart) {
                var totalPrice = Shopify.formatMoney(cart.total_price);
                totalPrice = totalPrice.replace('$', '£');
                $('#cart-total').text(totalPrice);
            });
        }, 750);
    }
    
    $('.gallery-product-image img').click(function (e) { 
        var currentProductImg   = $('.header-product-image img');
        var imgSrc              = $(this).attr('src');
        var targetSrc           = currentProductImg.attr('src');

        currentProductImg.attr('src', imgSrc);
        $(this).attr('src', targetSrc);

        // $('.variant-images').children('img').each(function () {
        //     var src = $(this).attr('src');

        //     if (src == imgSrc) {
        //         var id = $(this).attr('id')
        //         $('#select-' + id).trigger('click');
        //     }
        // });
        
    });


    // Looks


    $('#add-collection-to-cart').click(function (e) { 
        e.preventDefault();

        addLookToCart();
    });

    
    function addLookToCart() {
        var quantity = 1;
        var products = [];
        var counter = 0;

        $('.collection-grid-item').each(function (index, element) {
            products.push($(this).attr('data-item-id'));
        });

        counter = products.length;

        // setTimeout(() => {
        //     $.when(updateCart()).then(openCart());
        // }, 2000);

        loopCart(products, counter);

    }

    function loopCart(products, counter) {

        if (counter > 0 ) {
            counter--;
            Shopify.addItem(products[counter], 1, function() {
                loopCart(products, counter);
            });
        }

        if (counter == 0) {
            $.when(updateCart()).then(openCart());
        }
    }


    // Cart

    if (cartMode == "rentals") {
        $('#rentals-sidecart').css({
            "background-color": "#656565",
            "border": "1px solid #656565",
            "color": "white"
        })

        $('.rental-items').css({
            "display": "block",
        })

        $('.sales-items').css({
            "display": "none",
        })

        $('.rental-buttons').css({
            "display": "block",
        })

        $('.sales-buttons').css({
            "display": "none",
        })


        $('.rentail-cart-fields-grid').css({
            "display": "grid",
        })

        $('.rentail-cart-fields-block').css({
            "display": "block",
        })

        $('.sales-cart-fields').css({
            "display": "none",
        })

        $('.side-cart-calendar').css("display", "block");

        if (rentItemsAdded == "false") {
            $('#cart-total-shop-holder').css({
                "display": "none",
            })
            
            $('#cart-total-rental-holder').css({
                "display": "none",
            })

            $('.rental-items').css({
                "display": "none",
            })

            $('.cart-extra-info').css({
                "display": "none",
            })

            $('.empty-cart-alert').css({
                "display": "block",
            })

            $('.empty-side-cart-alert').css({
                "display": "block",
            })


        } else {

            $('#cart-total-shop-holder').css({
                "display": "none",
            })

            $('#cart-total-rental-holder').css({
                "display": "grid",
            })

            $('.cart-extra-info').css({
                "display": "block",
            })

            $('.empty-cart-alert').css({
                "display": "none",
            })

            $('.empty-side-cart-alert').css({
                "display": "none",
            })
        }


    } else {

        $('#sales-sidecart').css({
            "background-color": "#656565",
            "border": "1px solid #656565",
            "color": "white"
        })

        $('.rental-items').css({
            "display": "none",
        })

        $('.sales-items').css({
            "display": "block",
        })

        $('.rental-buttons').css({
            "display": "none",
        })

        $('.sales-buttons').css({
            "display": "block",
        })


        $('.rentail-cart-fields-grid').css({
            "display": "none",
        })

        $('.rentail-cart-fields-block').css({
            "display": "none",
        })

        $('.sales-cart-fields').css({
            "display": "block",
        })

        $('.side-cart-calendar').css("display", "none");

        if (salesItemsAdded == "false") {
            $('#cart-total-shop-holder').css({
                "display": "none",
            })

            $('#cart-total-rental-holder').css({
                "display": "none",
            })

            $('.cart-extra-info').css({
                "display": "none",
            })
            
            $('.empty-cart-alert').css({
                "display": "block",
            })

            $('.empty-side-cart-alert').css({
                "display": "block",
            })

            $('.sales-items').css({
                "display": "none",
            })
    
        } else {
            $('#cart-total-shop-holder').css({
                "display": "grid",
            })

            $('#cart-total-rental-holder').css({
                "display": "none",
            })

            $('.cart-extra-info').css({
                "display": "block",
            })

            $('.empty-cart-alert').css({
                "display": "none",
            })

            $('.empty-side-cart-alert').css({
                "display": "none",
            })
        }
    }

    $('#rentals-sidecart').click(function (e) { 
        e.preventDefault();

        cartMode = "rentals";
        localStorage.setItem("cartMode", "rentals")

        // dumpCart();

        $(this).css({
            "background-color": "#656565",
            "border": "1px solid #656565",
            "color": "white"
        })

        $('#sales-sidecart').css({
            "background-color": "white",
            "border": "1px solid black",
            "color": "black"
        })

        $('.rental-items').css({
            "display": "block",
        })

        $('.sales-items').css({
            "display": "none",
        })

        $('.rental-buttons').css({
            "display": "block",
        })

        $('.sales-buttons').css({
            "display": "none",
        })

        $('.rentail-cart-fields-grid').css({
            "display": "grid",
        })

        $('.rentail-cart-fields-block').css({
            "display": "block",
        })

        $('.sales-cart-fields').css({
            "display": "none",
        })


        if (rentItemsAdded == "false") {
            $('#cart-total-shop-holder').css({
                "display": "none",
            })

            $('#cart-total-rental-holder').css({
                "display": "none",
            })

            $('.cart-extra-info').css({
                "display": "none",
            })

            $('.empty-cart-alert').css({
                "display": "block",
            })

            $('.empty-side-cart-alert').css({
                "display": "block",
            })
        } else {
            $('#cart-total-shop-holder').css({
                "display": "none",
            })

            $('#cart-total-rental-holder').css({
                "display": "grid",
            })

            $('.cart-extra-info').css({
                "display": "block",
            })

            $('.empty-cart-alert').css({
                "display": "none",
            })

            $('.empty-side-cart-alert').css({
                "display": "none",
            })
        }


        $('.side-cart-calendar').css("display", "block");
        
    });

    $('#sales-sidecart').click(function (e) { 
        e.preventDefault();
        
        cartMode = "sales";
        localStorage.setItem("cartMode", "sales")
        
        // dumpCart();

        $(this).css({
            "background-color": "#656565",
            "border": "1px solid #656565",
            "color": "white"
        })

        $('#rentals-sidecart').css({
            "background-color": "white",
            "border": "1px solid black",
            "color": "black"
        })

        $('.rental-items').css({
            "display": "none",
        })

        $('.sales-items').css({
            "display": "block",
        })

        $('.rental-buttons').css({
            "display": "none",
        })

        $('.sales-buttons').css({
            "display": "block",
        })

        $('.rentail-cart-fields-grid').css({
            "display": "none",
        })

        $('.rentail-cart-fields-block').css({
            "display": "none",
        })

        $('.sales-cart-fields').css({
            "display": "block",
        })

        if (salesItemsAdded == "false") {
            $('#cart-total-shop-holder').css({
                "display": "none",
            })

            $('#cart-total-rental-holder').css({
                "display": "none",
            })
            
            $('.empty-cart-alert').css({
                "display": "block",
            })

            $('.empty-side-cart-alert').css({
                "display": "block",
            })
        } else {
            $('#cart-total-shop-holder').css({
                "display": "grid",
            })

            $('#cart-total-rental-holder').css({
                "display": "none",
            })

            $('.cart-extra-info').css({
                "display": "block",
            })

            $('.empty-cart-alert').css({
                "display": "none",
            })

            $('.empty-side-cart-alert').css({
                "display": "none",
            })
        }

        $('.side-cart-calendar').css("display", "none");
    });

    $('.cart-back').click(function (e) { 
        e.preventDefault();
        
        if (document.referrer.includes('collections') || document.referrer.includes('products')) {
            history.go(-1);
        } else {
            window.location.href = window.location.origin + "/collections/dinner-plates-shop";
        }
    });

    $('#view-basket').click(function (e) { 
        e.preventDefault();
        
        cartMode = "sales";
        localStorage.setItem("cartMode", "sales")

        window.location.href = "/cart";
    });

    $('#view-enqiry').click(function (e) { 
        e.preventDefault();
        
        cartMode = "rentals";
        localStorage.setItem("cartMode", "rentals")

        window.location.href = "/cart";
    });


    $('#open-cart').click(function (e) { 
        e.preventDefault();
   
        $('.side-cart').css('right', 0);
        $('body, html').css('overflow', 'hidden');
        $('.side-cart-hider').css('display', 'block');

        if (cartMode == "rentals") {
            $('#rentals-sidecart').css({
                "background-color": "#656565",
                "border": "1px solid #656565",
                "color": "white"
            })

            $('#sales-sidecart').css({
                "background-color": "white",
                "border": "1px solid black",
                "color": "black"
            })
    
            $('.rental-items').css({
                "display": "block",
            })
    
            $('.sales-items').css({
                "display": "none",
            })
    
            $('.rental-buttons').css({
                "display": "block",
            })
    
            $('.sales-buttons').css({
                "display": "none",
            })
    
    
            $('.rentail-cart-fields-grid').css({
                "display": "grid",
            })
    
            $('.rentail-cart-fields-block').css({
                "display": "block",
            })
    
            $('.sales-cart-fields').css({
                "display": "none",
            })
    
            $('.side-cart-calendar').css("display", "block");
    
    
        } else {
    
            $('#sales-sidecart').css({
                "background-color": "#656565",
                "border": "1px solid #656565",
                "color": "white"
            })

            $('#rentals-sidecart').css({
                "background-color": "white",
                "border": "1px solid black",
                "color": "black"
            })
    
    
            $('.rental-items').css({
                "display": "none",
            })
    
            $('.sales-items').css({
                "display": "block",
            })
    
            $('.rental-buttons').css({
                "display": "none",
            })
    
            $('.sales-buttons').css({
                "display": "block",
            })
    
    
            $('.rentail-cart-fields-grid').css({
                "display": "none",
            })
    
            $('.rentail-cart-fields-block').css({
                "display": "none",
            })
    
            $('.sales-cart-fields').css({
                "display": "block",
            })
    
            $('.side-cart-calendar').css("display", "none");
        }

    });

    $('#open-cart-mobile').click(function (e) { 
        e.preventDefault();
   
        $('.side-cart').css('right', 0);
        $('body, html').css('overflow', 'hidden');
        $('.side-cart-hider').css('display', 'block');
    });

    $('#close-cart').click(function (e) { 
        e.preventDefault();
        
        $('.side-cart').css('right', -720);
        $('.side-cart-hider').css('display', 'none');

        if (!mobileMenuOpen) {
            $('body, html').css('overflow', 'auto');
        }

    });

    $('.close-cart').click(function (e) { 
        e.preventDefault();
        
        $('.side-cart').css('right', -720);
        $('.side-cart-hider').css('display', 'none');
        
        if (!mobileMenuOpen) {
            $('body, html').css('overflow', 'auto');
        }
    });

    $('.side-cart-hider').click(function (e) { 
        e.preventDefault();
        
        $('.side-cart').css('right', -720);
        $('.side-cart-hider').css('display', 'none');
        
        if (!mobileMenuOpen) {
            $('body, html').css('overflow', 'auto');
        }
    });

    $('.quantity-select').change(function (e) { 
        e.preventDefault();
        
        var num = $("option:selected", this).attr('value');
        var id  = $(this).attr('data-variant-id');
        
        Shopify.changeItem(id, num);

        var priceHolder = $(this).parent().next().find('#cart-product-price-original');
        var price       = priceHolder.text();
        price = Shopify.formatMoney(price);



        console.log("subtotal - " + price);

        price = convertCurrency(price, num)

        console.log(price);

        $(this).parent().next().find('#cart-product-price').text(price);

        setTimeout(() => {
            updateCart();
        }, 500);

        
    });

    $('#cart-checkout').click(function (e) { 
        e.preventDefault();

        $('.cart-loader').fadeIn(500);

        userCheckout = true;
        localStorage.setItem("userCheckout", userCheckout);
        dumpCart();
    });

    function updateCart() {

        var priceCounterRental = 0;
        var priceCounterShop = 0;

        Shopify.getCart(function(cart) {
            var cartItems       = cart.items;
            var counter         = 0;
            var counterSales    = 0;
            var counterRental   = 0;

            var text;
            var itemsArray      = [];
        
            var imageHolder;
            var titleHolder;
            var linkHolder;
            var imgLinkHolder;
            var subtotalHolder;
            var originalPriceHolder;
            var subtotalHolderMain;
            var quantityHolder;
            var selectorHolder;
            var closeButton;

            var currencyPriceHolder;
            var price;
            var priceInt;
            var quantity;
            var totalShop;
            var totalRental;
    
            var dateHolder;
            var date = localStorage.getItem("selectedDate");

            var totalPrice;

            var selector    = "";
            var sku         = "";

            cartItems.forEach(element => {

                sku = element.sku;

                if (sku.includes("_S_")) {
                    selector = "sales";
                    counterSales++;
                    counter = counterSales;
                    salesItemsAdded = "true";
                    localStorage.setItem("salesItemsAdded", "true")

                } else {
                    selector = "rental"
                    counterRental++;
                    counter = counterRental;
                    rentItemsAdded = "true";
                    localStorage.setItem("rentItemsAdded", "true")
                }

                $('.cart-item-' + selector + '-' + counter).css('display', 'grid');
            

                imageHolder = $('#item-' + selector + '-' + counter + '.cart-item-img img');
    
                var img = element.image;
                img = Shopify.resizeImage(img, "200x");
                imageHolder.attr('src', img);
    
                /////////////////////////////////////////////////////////////////////////////////////
    
                imgLinkHolder = $('#item-' + selector + '-' + counter + '.cart-item-img #cart-item-link');
                imgLinkHolder.attr('href', element.url);
    
    
                /////////////////////////////////////////////////////////////////////////////////////
    
                titleHolder = $('#item-' + selector + '-' + counter + '.cart-title #cart-item-title');
                titleHolder.text(element.product_title);
                titleHolder.attr('data-variant-id', element.id);
                titleHolder.attr('data-product-name', element.title);
    
                /////////////////////////////////////////////////////////////////////////////////////
        
                linkHolder = $('#item-' + selector + '-' + counter + '.cart-title #cart-item-link');
                linkHolder.attr('href', element.url);

                /////////////////////////////////////////////////////////////////////////////////////
    
                if ($('.quantity-select').length) {
                    selectorHolder = $('#item-' + selector + '-' + counter + '.cart-quantity .quantity-select');
                    selectorHolder.val(element.quantity);
                    selectorHolder.attr('data-variant-id', element.id);
                    quantity = selectorHolder.val();
                }
    
                /////////////////////////////////////////////////////////////////////////////////////

                currencyPriceHolder  = $('#item-' + selector + '-' + counter + '.cart-subtotal #cart-product-price-currency');
                price                = Shopify.formatMoney(element.price);

                text = convertCurrency(price, quantity);
    
                subtotalHolder = $('#item-' + selector + '-' + counter + '.cart-subtotal #cart-product-price');
                subtotalHolder.text(text);
    
                originalPriceHolder = $('#item-' + selector + '-' + counter + '.cart-subtotal #cart-product-price-original');
                originalPriceHolder.text(element.price);
    
                /////////////////////////////////////////////////////////////////////////////////////
    
                dateHolder = $('#item-' + selector + '-' + counter + '.cart-date #cart-product-date');
                dateHolder.text(date);
    
                /////////////////////////////////////////////////////////////////////////////////////
    
                quantityHolder = $('#item-' + selector + '-' + counter + '.quantity-select');
                quantityHolder.text(element.quantity);    

                quantityHolder = $('#item-' + selector + '-' + counter + '.cart-quantity');
                quantityHolder.find('#cart-quantity').text(element.quantity);

                ////////////////////////////////////////////////////////////////////////////////////
    
                closeButton = $('#item-' + selector + '-' + counter + '.cart-remove .remove-item');
                closeButton.attr('data-variant-id', element.id);
    
                ////////////////////////////////////////////////////////////////////////////////////

                if (text.includes("Dhs. ")) {
                    text = text.replace('Dhs. ', '')
                } else if (text.includes("SFr. ")) {
                    text = text.replace('SFr. ', '')
                }

                if (sku.includes("_S_")) {
                    priceCounterShop    = accounting.unformat(priceCounterShop);
                    priceInt            = accounting.unformat(text);
                    priceCounterShop    = priceCounterShop + priceInt;
                    totalShop           = accounting.formatMoney(priceCounterShop, { symbol: globalCurrency,  format: "%v %s" });

                    switch (globalCurrency) {
                        case 'USD':
                            totalShop = "$" + totalShop;
                            break;
                        case 'GBP':
                            totalShop = "£" + totalShop;
                            break;
            
                        case 'EUR':
                            totalShop = "€" + totalShop;
                            break;
            
                        case 'CAD':
                            totalShop = "$" + totalShop;
                            break;
            
                        case 'AUD':
                            totalShop = "$" + totalShop;
                            break;
            
                        case 'INR':
                            totalShop = "₹" + totalShop;
                            break;
            
                        case 'JPY':
                            totalShop = "¥" + totalShop;
                            break;
            
                        case 'NZD':
                            totalShop = "$" + totalShop;
                            break;
            
                        case 'CHF':
                            totalShop = "" + totalShop;
                            break;
            
                        case 'AED':
                            totalShop = "" + totalShop;
                            break;
                        default:
                            totalShop = "£" + totalShop;
                            break;
                    }

                } else {
                    priceCounterRental  = accounting.unformat(priceCounterRental);
                    priceInt            = accounting.unformat(text);
                    priceCounterRental  = priceCounterRental + priceInt;
                    totalRental         = accounting.formatMoney(priceCounterRental, { symbol: globalCurrency,  format: "%v %s" });

                    switch (globalCurrency) {
                        case 'USD':
                            totalRental = "$" + totalRental;
                            break;
                        case 'GBP':
                            totalRental = "£" + totalRental;
                            break;
            
                        case 'EUR':
                            totalRental = "€" + totalRental;
                            break;
            
                        case 'CAD':
                            totalRental = "$" + totalRental;
                            break;
            
                        case 'AUD':
                            totalRental = "$" + totalRental;
                            break;
            
                        case 'INR':
                            totalRental = "₹" + totalRental;
                            break;
            
                        case 'JPY':
                            totalRental = "¥" + totalRental;
                            break;
            
                        case 'NZD':
                            totalRental = "$" + totalRental;
                            break;
            
                        case 'CHF':
                            totalRental = "" + totalRental;
                            break;
            
                        case 'AED':
                            totalRental = "" + totalRental;
                            break;
                        default:
                            totalRental = "£" + totalRental;
                            break;
                    }
                }

                $('#cart-total-shop').text(totalShop);
                $('#cart-total-rental').text(totalRental);

                itemsArray.push(element);
                localStorage.setItem('itemsArray', JSON.stringify(itemsArray));
            });
            
            cartQuantity = counter;

        });
    }



    function dumpCart() {
        salesCart = [];
        rentCart = [];

        Shopify.getCart(function(cart) {
            var cartItems   = cart.items;
            var sku;

            cartItems.forEach(element => {

                sku = element.sku;

                if (sku.includes("_S_")) {
                    salesCart.push(element);
                    localStorage.setItem('salesCart', JSON.stringify(salesCart));
                } else {
                    rentCart.push(element);
                    localStorage.setItem('rentCart', JSON.stringify(rentCart));
                }

            });
        })

        setTimeout(() => {
            fillCart();
        }, 1000);

    }

    function fillCart() {

        Shopify.clear();
        Shopify.clear();

        setTimeout(() => {
            if (cartMode == "rentals") {
                var counter = 0;

                rentCart.forEach((element, i) => {
                    setTimeout(() => {
                        counter++;
                        Shopify.addItem(element.id, element.quantity);

                        if (counter == salesCart.length) {
                            setTimeout(() => {
                            rentCart = [];
                            }, 300);
                        }
                    }, i * 250);
                });
    
            } else {
                var counter = 0;

                salesCart.forEach((element, i) => {
                    setTimeout(() => {
                        counter++;
                        Shopify.addItem(element.id, element.quantity);

                        if (counter == salesCart.length) {
                            setTimeout(() => {
                            salesCart = [];
                            userNotified = false;
                            localStorage.setItem('userNotified', false);
                            window.location.href = "/checkout";
                            }, 300);
                        }
                    }, i * 250);
                }); 
            }   
        }, 1000);
    }

    function restoreCart(cart) {

        setTimeout(() => {
            if (cart == "rentals") {
                var counter = 0;

                rentCart.forEach((element, i) => {
                    setTimeout(() => {
                        counter++;
                        Shopify.addItem(element.id, element.quantity);

                        if (counter == rentCart.length) {
                            setTimeout(() => {
                                rentCart = [];
                                localStorage.setItem('rentCart', JSON.stringify(rentCart));
                                updateCart();
                            }, 300);
                        }
                    }, i * 250);
                });
    
            } else {
                var counter = 0;

                salesCart.forEach((element, i) => {
                    setTimeout(() => {
                        counter++;
                        Shopify.addItem(element.id, element.quantity);

                        if (counter == salesCart.length) {
                            setTimeout(() => {
                            salesCart = [];
                            localStorage.setItem('salesCart', JSON.stringify(salesCart));
                            updateCart();
                            }, 300);
                        }
                    }, i * 250);
                }); 
            }   

            checkCartItems();
        }, 1000);        
    }

    function checkCartItems() {
        var rentItem = false;

        if (itemsArray.length > 0) {
            for (let i = 0; i < itemsArray.length; i++) {
                const elm = itemsArray[i];
                const sku = elm.sku;  

                if (sku.includes("_S_")) {
                    salesItemsAdded = "true";
                    localStorage.setItem("salesItemsAdded", "true")
                } 

                if (!sku.includes("_S_")) {
                    rentItemsAdded = "true";
                    localStorage.setItem("rentItemsAdded", "true")
                    rentItem = true;

                } else if (!rentItem) {
                    rentItemsAdded = "false";
                    localStorage.setItem("rentItemsAdded", "false")
                }
            }
        } else {
            rentItemsAdded = "false";
            localStorage.setItem("rentItemsAdded", "false")

            salesItemsAdded = "false";
            localStorage.setItem("salesItemsAdded", "false")
        }



        if (userCheckout && rentItemsAdded == "true" && !userNotified ) {
            userNotified = true;
            userCheckout = false;
            localStorage.setItem("userCheckout", false);

            $('.notification-background').fadeIn();
            $('.rentals-notification').fadeIn(); 

            cartMode = "rentals"; 
            localStorage.setItem("cartMode", "rentals")
        } else {
            userCheckout = false;
            localStorage.setItem("userCheckout", false);
        }

        if (userRentals && !userNotified && salesItemsAdded == "true") {
            userNotified = true;
            userRentals = false;
            localStorage.setItem("userRentals", false);

            $('.notification-background').fadeIn();
            $('.shop-notification').fadeIn();

            cartMode = "sales";
            localStorage.setItem("cartMode", "sales")
        } else {
            userRentals = false;
            localStorage.setItem("userRentals", false);
        }
    }

    $('.cart-notification').hover(function () {

        if (this.hasClass('stock-notification')) {
            return false;
        } 
            $(this).css("background-color" , "#9f9f9f")
            $('.cart-notification div').css({
                "background-color" : "#9f9f9f",
                "border" : "1px solid white",
                "outline" : "1px solid white"
            })

            $('.cart-notification div p').css({
                "color" : "white"
            })

            $('.cart-notification div a').css({
                "color" : "white"
            })

        }, function () {
            $(this).css("background-color" , "white")
            $('.cart-notification div').css({
                "background-color" : "white",
                "border" : "1px solid black",
                "outline" : "1px solid black"
            })

            $('.cart-notification div p').css({
                "color" : "black"
            })

            $('.cart-notification div a').css({
                "color" : "black"
            })
        }
    );

    $('.cart-notification').click(function (e) { 
        e.preventDefault();

        if (this.hasClass('stock-notification')) {
            return false;
        } else {
            userNotified = true;
            window.location.href = "/cart";
        }
        


    });

    $('.notification-background').click(function (e) { 
        e.preventDefault();


        $('.notification-background').fadeOut();
        $('.shop-notification').fadeOut();
        $('.rentals-notification').fadeOut();
        $('.stock-notification').fadeOut();
    });

    function openCart() {
        
        setTimeout(() => {
            $('#open-cart').trigger('click');
        }, 200);

    }

    $('#plus-people').click(function (e) { 
        e.preventDefault();

        var num = parseInt($('#quantity-people').html());
        num = num + 1;
        pad(num, 4, 2);
    });

    $('#minus-people').click(function (e) { 
        e.preventDefault();

        var num = parseInt($('#quantity-people').html());

        if (num > 0) {
            num = num - 1;
        } 

        pad(num, 4, 2);
    });

    $('body').on('click', '.vanilla-calendar-date', function(){
        
        var date    = $(this).attr('data-calendar-date');
        var msec    = Date.parse(date);
        var dateObj = new Date(msec);
        var dateStr = dateObj.toLocaleDateString();

        localStorage.setItem("selectedDate", dateStr);

        if ($('.cart-date p').length) {
            $('.cart-date p').each(function () {
                $(this).text(dateStr);
            });
        }
    });


    if ($('.vanilla-calendar')) {
        var date = localStorage.getItem("selectedDateButton");

        var elm = $('.vanilla-calendar').find("[data-calendar-date='"+ date +"']");
        
        elm.addClass('vanilla-calendar-date--selected');   
    }

    $('#confirm-enquiry').click(function (e) { 
        e.preventDefault();

        if ($('#terms-check').is(":checked")) {
            var name        = $('#user-name').val();
            var surname     = $('#user-surname').val();
            var email       = $('#user-email').val();
            var address     = $('#user-address').val();
            var country     = $('#user-country').val();
            var city        = $('#user-city').val();
            var postcode    = $('#user-postcode').val();
            var note        = $('#user-note').val();
            var phone       = $('#user-phone').val();
            var id          = $(this).attr('data-customer-id');
    
            if (name == "") {
                $('#user-name').css("border", "1px solid red");
                $('#cart-alert-missing').fadeIn();
            } else if (surname == "") {
                $('#user-surname').css("border", "1px solid red");
                $('#cart-alert-missing').fadeIn();
            } else if (email == "") {
                $('#user-email').css("border", "1px solid red");
                $('#cart-alert-missing').fadeIn();
            } else if (address == "") {
                $('#user-address').css("border", "1px solid red");
                $('#cart-alert-missing').fadeIn();
            } else if (city == "") {
                $('#user-city').css("border", "1px solid red");
                $('#cart-alert-missing').fadeIn();
            } else if (postcode == "") {
                $('#user-postcode').css("border", "1px solid red");
                $('#cart-alert-missing').fadeIn();
            } else if (phone == "") {
                $('#user-postcode').css("border", "1px solid red");
                $('#cart-alert-missing').fadeIn();
            } else if (country == "") {
                $('#user-country').css("border", "1px solid red");
                $('#cart-alert-missing').fadeIn();
            } else if (cartQuantity <= 0) {
                $('#cart-alert-items').fadeIn();
            } else if (!localStorage.getItem("selectedDate")) {
                $('#cart-alert-date').fadeIn();
            } else {
                var userDetails = {
                    name: name, 
                    surname: surname,
                    email: email,
                    address: address,
                    country: country,
                    city: city,
                    postcode: postcode,
                    phone: phone,
                    note: note,
                    id: id
                }
                
                // console.log('Sending email...');
                $('.cart-loader').fadeIn(500);

                dumpCart();

                setTimeout(() => {
                    userRentals = true;
                    localStorage.setItem('userRentals', true);

                    sendEnquiry(userDetails);
                    sendConformation(userDetails);
            
                    createOrder(userDetails);
                    
                    $('#cart-alert').fadeIn();
                }, 3000);
            }
        } else {
            $('#cart-alert-terms').fadeIn();
        }


    });

    function createBodyEnquiry(userDetails) {
        var date = localStorage.getItem("selectedDate");

        var body = "<h1>New Order Details<h1>" 
        + "<p>Hire Date: " + date + " </p>"
        + "<br>" 
        + "Items Ordered: "
        + "<br>" 

        for (let i = 0; i < rentCart.length; i++) {
            const item = rentCart[i];

            var price = Shopify.formatMoney(item.line_price);
            price = price.replace('$', '£');

            body += "" + item.product_title + " x " + item.quantity + " - " + price + "<br>";
        }

        body += "<br><p>Total: " + totalPrice + "</p>"
        + "<br></br>"
        + "Customer Details: "
        + "<br>" 
        + "First Name: " + userDetails.name 
        + "<br>" 
        + "Last Name: " + userDetails.surname
        + "<br>" 
        + "Email: " + userDetails.email
        + "<br>" 
        + "Address: " + userDetails.address
        + "<br>" 
        + "Town/City: " + userDetails.city
        + "<br>" 
        + "Country: " + userDetails.country
        + "<br>" 
        + "Postcode: " + userDetails.postcode
        + "<br>" 
        + "Phone Number: " + userDetails.phone
        + "<br></br>"
        + "Note: "
        + "<br>"
        + userDetails.note;

        return body;
    }

    function sendEnquiry(userDetails) {
        Email.send({
            Host : "smtp.office365.com",
            Username : "rentals@maisonmargauxltd.com",
            Password : "WNthT-P4_T%4hD--",
            To : 'rentals@maisonmargauxltd.com',
            From : "rentals@maisonmargauxltd.com",
            Subject : "New Order Notification",
            Body : createBodyEnquiry(userDetails)
        }).then(
          message => alert(message)
        );
    }

    function createBodyConformation(userDetails) {
        var date = localStorage.getItem("selectedDate");

        var body = "<style>"
        + "</style>"
        + "<div style=\"max-width: 720px; margin: 0 auto;text-align: center !important;color:black !important;\">"
        + "<img src=\" https://i.ibb.co/3RwmJBR/logo.png \" style=\"width:100%;height:auto;max-width:280px;margin:0 auto;margin-bottom:40px;\" />"
        + "<h1 style=\"font-family: europa, sans-serif !important;font-weight: 600 !important;font-size:26px !important;text-align:center !important;\">Thank you for your enquiry</h1>" 
        + "<br>"
        + "<p style=\"font-family: europa, sans-serif !important;font-weight: 300 !important;font-size:20px !important;text-align:center !important;\">We will review your requested products for your desired date and will be in touch to confirm availability within 24 hours.</p>"
        + "<p style=\"font-family: europa, sans-serif !important;font-weight: 300 !important;font-size:16px !important;text-align:center !important;font-style: italic;\">Please note that this is a confirmation of your enquiry only. Your hire order is not reserved until we have confirmed your chosen products are available for your event date.</p>"
        + "<br>"
        + "<p style=\"font-family: europa, sans-serif !important;font-weight: 300 !important;font-size:20px !important;text-align:center !important;\">Please find a summary of your enquiry below:</p>"
        + "<br>"
        + "<p style=\"font-family: europa, sans-serif !important;font-weight: 600 !important;font-size:20px !important;text-align:left !important;\">Hire Date: " + date + "</p>"
        + "</br>"
        + "<p style=\"font-family: europa, sans-serif !important;font-weight: 600 !important;font-size:20px !important;text-align:left !important;\">Products requested: </p>"

        for (let index = 0; index < rentCart.length; index++) {
            const item = rentCart[index];

            var price = Shopify.formatMoney(item.line_price);
            price = price.replace('$', '£');

            body += "<p style=\"font-family: europa, sans-serif !important;font-weight: 300 !important;font-size:20px !important;text-align:left !important;color:black !important\">" 
            + item.product_title + " x " + item.quantity + " - " + price 
            + "</p>";
        }

        body += "<p style=\"font-family: europa, sans-serif !important;font-weight: 300 !important;font-size:20px !important;text-align:left !important;\">Product Total: " + totalPrice + "</p>"
        + "<br>"
        + "<p style=\"font-family: europa, sans-serif !important;font-weight: 600 !important;font-size:20px !important;text-align:left !important;\">"
        + "Notes: "
        + "</p>"
        + "<p style=\"font-family: europa, sans-serif !important;font-weight: 300 !important;font-size:20px !important;text-align:left !important;\">"
        + userDetails.note
        + "</p>"
        + "</div>";

        return body;
    }

    function sendConformation(userDetails) {
        Email.send({
            Host : "smtp.office365.com",
            Username : "rentals@maisonmargauxltd.com",
            Password : "WNthT-P4_T%4hD--",
            To : userDetails.email,
            From : "rentals@maisonmargauxltd.com",
            Subject : "Maison Margaux Enquiry",
            Body : createBodyConformation(userDetails)
        }).then(
          message => console.log(message)
        );
    }


    // ORDER API 

    function createOrder(userDetails) {
        var date = localStorage.getItem("selectedDate");
        var text = "Hire Date: " + date + "\n";   

        var data = {
            draft_order:{
                line_items:{},
                shipping_address:{},
                email: userDetails.email,
                customer:{
                    id: userDetails.id,
                    email: userDetails.email
                },
                note: text + userDetails.note,
                taxes_included: true,
                status: "open"
            }
        };

        var products = [];

        for (let i = 0; i < rentCart.length; i++) {
            const element = rentCart[i];
            
            item = {}
            item["title"]       = element.product_title;
            item["name"]        = element.title;
            item["product_id"]  = element.product_id;
            item["variant_id"]  = element.variant_id;
            item["quantity"]    = element.quantity;
            item["price"]       = element.price;

            products.push(item);
        }

        data.draft_order.line_items = products;

        var shippingAddress = {
            "first_name": userDetails.name,
            "last_name": userDetails.surname,
            "address1": userDetails.address,
            "city": userDetails.city,
            "country": userDetails.country,
            "zip": userDetails.postcode,
            "phone": userDetails.phone
        };

        data.draft_order.shipping_address = shippingAddress;

        var dataString = JSON.stringify(data);
        
        $.ajax({
            type: "POST",
            url: api_url,
            contentType: "application/json",
            dataType: 'json',
            data: dataString,
            success: function(result){
               console.log('CALL SUCCESSFULL');
            },
            error: function(result){
                console.log('CALL UNSUCCESSFUL');

                $.when(Shopify.clear()).then(updateCart());
                window.location.href = "https://maisonmargauxltd.com/pages/confirmation";
             }
        })
    }

    if ($('.recent-orders').length) {
        getOrders();
    }

    function getOrders() {
        var orders; 

        $.ajax({
            type: "GET",
            url: api_url,
            contentType: "application/json",
            dataType: 'json',
            success: function(result){
               console.log('CALL SUCCESSFULL');

               orders = result
               filterOrders(orders);
            },
            error: function(result){
                console.log('CALL UNSUCCESSFUL');
            }
        })
    }


    function filterOrders(orders) {
        var id = $('.data').attr('data-customer-id');
        
        var keys         = getKeyByID(orders, id);

        keys.forEach(element => {
            customerOrders.push(orders[element]);
        });

        customerOrders = customerOrders.reverse();
        
        displayCustomerOrders();
        displayCustomerOrdersClosed();
    }

    function getKeyByID (obj, id) {
        var returnKey = [];

        $.each(obj, function(key, info) {
            if (info.customer) {
                if (info.customer.id == id) {
                    returnKey.push(key);
                 };   
            }
        });
    
        return returnKey;      
    }

    function displayCustomerOrders() {
        var parent      = $('.orders-open');
        var counter     = 0;
        var subCounter  = 0;

        customerOrders.forEach(element => {
            counter++;

            if (element.status != "completed") {
                $(parent).append(
                    $('<div class=\"order-item\" id=\"order-item-' + counter + '\"></div>')
                        .append($('<div class=\"order-title\"></div>').append($('<p>ORDER: </p><span>' + element.name + '</span>')))
                );
    
                $('#order-item-' + counter).append($('<div class=\"order-info\"></div>').append($('<div class=\"order-grid\"></div>')));
    
                element.line_items.forEach(product => {
                    subCounter++;
    
                    $('#order-item-' + counter + ' .order-grid')
                    .append($('<div class=\"product-title\"></div>').append($('<p>' + product.title + '</p>')))
                    .append($('<div class=\"product-quantity\"></div>').append($('<p>QTY: ' + product.quantity + '</p>')));
                });
    
                $('#order-item-' + counter + ' .order-info').append($('<div class=\"order-note\"></div>').append($('<p>NOTE:<br>' + element.note + '</p>')))
    
                if (element.invoice_sent_at) {
                    $('#order-item-' + counter + ' .order-info').append($('<a href=\"' + element.invoice_url + '\" class=\"order-button\"></a>').append($('<button class="available">PAY FOR ORDER</button>')));
                } else {
                    $('#order-item-' + counter + ' .order-info').append($('<a href=\"\" class=\"order-button\"></a>').append($('<button class="unavailable">AWAITING APPROVAL</button>')));
                }
            }
            

        });
        
    }

    function displayCustomerOrdersClosed() { 
        var parent      = $('.orders-closed');
        var counter     = 0;
        var subCounter  = 0;

        customerOrders.forEach(element => {
            counter++;

            if (element.status == "completed") {
                $(parent).append(
                    $('<div class=\"order-item\" id=\"order-item-' + counter + '\"></div>')
                        .append($('<div class=\"order-title\"></div>').append($('<p>ORDER: </p><span>' + element.name + '</span>')))
                );
    
                $('#order-item-' + counter).append($('<div class=\"order-info\"></div>').append($('<div class=\"order-grid\"></div>')));
    
                element.line_items.forEach(product => {
                    subCounter++;
    
                    $('#order-item-' + counter + ' .order-grid')
                    .append($('<div class=\"product-title\"></div>').append($('<p>' + product.title + '</p>')))
                    .append($('<div class=\"product-quantity\"></div>').append($('<p>QTY: ' + product.quantity + '</p>')));
                });
    
                $('#order-item-' + counter + ' .order-info').append($('<div class=\"order-note\"></div>').append($('<p>NOTE:<br>' + element.note + '</p>')))
    

                $('#order-item-' + counter + ' .order-info').append($('<a href=\"\" class=\"order-button\"></a>').append($('<button class="unavailable">PAID</button>')));

            }
            
        });
    }


    $('.logout').click(function (e) { 
        Shopify.clear();
    });

    $('.item').click(function (e) { 
        e.preventDefault();

        var elm = $(this).attr('data-item');

        $('.account-info').css("display", "none");
        $('#' + elm).fadeIn();
        
    });

    $('.orders').on('click', '.order-title', function(){
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).next().slideUp(500);
        } else {
            $(this).addClass('active');
            $(this).next().slideDown(500);
        }
    });

    $('.edit-address, .add-address').click(function (e) { 
        e.preventDefault();

        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.edit-address-form').slideUp(500);
        } else {
            $(this).addClass('active');
            $('.edit-address-form').slideDown(500);
        }
    });

    $('#login-link').click(function (e) { 
        e.preventDefault();
        localStorage.setItem('currentURL', currentUrl);
        
        window.location.href = "/account/login";
    });

    if (localStorage.getItem('currentURL')) {
        $('#login-redirect').attr('value', "/cart");
    }

    $('#cart-register').click(function (e) { 
        e.preventDefault();
        localStorage.setItem('currentURL', currentUrl);
        
        window.location.href = "/account/register";
    });

    if (localStorage.getItem('currentURL')) {
        $('#register-redirect').attr('value', "/cart");
    }

    $('.prompt-button').click(function (e) { 
        e.preventDefault();

        if ($(this).hasClass('form-open')) {
            createRegistration();
        } else {
            checkRegDetails();
        }

    });

    function checkRegDetails() {
        var name        = $('#user-name').val();
        var surname     = $('#user-surname').val();
        var email       = $('#user-email').val();
        var pass        = $('#user-pass').val();
        var passConf    = $('#user-passConf').val();
        var note        = $('#user-note').val();

        // Shipping Address
        var address     = $('#user-address').val();
        var country     = $('#user-country').val();
        var city        = $('#user-city').val();
        var postcode    = $('#user-postcode').val();
        var phone       = $('#user-phone').val();

        var userDetailsReg;
        
        if (name == "") {
            $('#user-name').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (surname == "") {
            $('#user-surname').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (email == "") {
            $('#user-email').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (address == "") {
            $('#user-address').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (city == "") {
            $('#user-city').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (postcode == "") {
            $('#user-postcode').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (phone == "") {
            $('#user-postcode').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else {
            $('#login-link').fadeOut(100);
            $('.cart-details-hidden').fadeIn();
            $('.prompt-button').addClass('form-open');
        }
    }

    function createRegistration() {
        var name        = $('#user-name').val();
        var surname     = $('#user-surname').val();
        var email       = $('#user-email').val();
        var pass        = $('#user-pass').val();
        var passConf    = $('#user-passConf').val();
        var note        = $('#user-note').val();

        // Shipping Address
        var address     = $('#user-address').val();
        var country     = $('#user-country').val();
        var city        = $('#user-city').val();
        var postcode    = $('#user-postcode').val();
        var phone       = $('#user-phone').val();

        var userDetailsReg;
        
        if (name == "") {
            $('#user-name').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (surname == "") {
            $('#user-surname').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (email == "") {
            $('#user-email').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (address == "") {
            $('#user-address').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (city == "") {
            $('#user-city').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (postcode == "") {
            $('#user-postcode').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (phone == "") {
            $('#user-postcode').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (pass == "") {
            $('#user-pass').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else if (passConf == "") {
            $('#user-passConf').css("border", "1px solid red");
            $('#cart-alert-missing').fadeIn();
        } else {

            if (pass != passConf) {
                $('#user-pass').css("border", "1px solid red");
                $('#user-passConf').css("border", "1px solid red");
                $('#cart-alert-pass').fadeIn();
            } else {
                userDetailsReg = {
                    name: name, 
                    surname: surname,
                    email: email,
                    address1: address,
                    country: country,
                    city: city,
                    postcode: postcode,
                    phone: phone,
                    password: pass,
                    password_confirmation: passConf,
                    note: note
                }

                localStorage.setItem('registerAddress', JSON.stringify(userDetailsReg));
                localStorage.setItem('userRegistered', "true");

                
                $('#login-email').val(email);
                $('#login-password').val(pass);

                sameAddress = true;
                registerAccount(userDetailsReg);
            }
        }
    }

    if (localStorage.getItem('userRegistered') == "true" && $('.cart-details').length) {
        var data = JSON.parse(localStorage.getItem('registerAddress'));

        $('#user-name').val(data.name);
        $('#user-surname').val(data.surname);
        $('#user-email').val(data.email);
        $('#user-address').val(data.address1);
        $('#user-country').val(data.country);
        $('#user-city').val(data.city);
        $('#user-postcode').val(data.postcode);
        $('#user-phone').val(data.phone);
        $('#user-note').val(data.note);

        localStorage.setItem('userRegistered', "false");
    }

    function registerAccount(userDetailsReg) {

        var data = {
            customer:{
                first_name: userDetailsReg.name,
                last_name: userDetailsReg.surname,
                email: userDetailsReg.email,
                phone: userDetailsReg.phone,
                verified_email: true,
                addresses:{},
                password: userDetailsReg.password,
                password_confirmation: userDetailsReg.password_confirmation,
                send_email_welcome: false
            }
        };
        
        var addresses = [];
        var item = {};

        item["first_name"]  = userDetailsReg.name;
        item["last_name"]   = userDetailsReg.surname;
        item["address1"]    = userDetailsReg.address1;
        item["country"]     = userDetailsReg.country;
        item["city"]        = userDetailsReg.city;
        item["zip"]         = userDetailsReg.postcode;
        item["phone"]       = userDetailsReg.phone;
        item["default"]     = true;

        addresses.push(item);

        data.customer.addresses = addresses;

        var dataString = JSON.stringify(data);
        $.ajax({
            type: "POST",
            url: api_url,
            contentType: "application/json",
            dataType: 'json',
            data: dataString,
            success: function(result){
               console.log('CALL SUCCESSFULL');
            },
            error: function(result){
                console.log('CALL UNSUCCESSFUL');
                

                if (result.responseText.includes('error') && result.responseText.includes('email -')) {
                    $('#cart-alert-email').fadeIn();
                } else if (result.responseText.includes('error') && result.responseText.includes('phone -')) {
                    $('#cart-alert-phone').fadeIn();
                } else {
                    loginUser();
                }
            }
        })
    }

    function loginUser() {
        $('#customer_login').trigger('submit');
    }

    // Newsletter

    if ($('.contact-banner').length) {
        var $form = $('.contact-banner form');
    }

    if ($('.contact-form').length) {
        var $form = $('#mc_embed_signup form');
    }



    $('#contact-signup').click(function (e) { 
        e.preventDefault();
        
        var fname = $('#newsletter-fname').val();
        var lname = $('#newsletter-lname').val();
        var email = $('#newsletter-email').val();

        var form_fname = $('#mce-FNAME');
        var form_lname = $('#mce-LNAME');
        var form_email = $('#mce-EMAIL');

        var error = $('.newsletter-alert p');

        if (fname == "") {
            error.text('PLEASE FILL IN YOUR NAME')
            error.fadeIn(200);

        } else if (lname == "") {
            error.text('PLEASE FILL IN YOUR LAST NAME')
            error.fadeIn(200);

        } else if (email == "") {
            error.text('PLEASE FILL IN YOUR EMAIL')
            error.fadeIn(200);

        } else {
            form_fname.val(fname);
            form_lname.val(lname);
            form_email.val(email);


            register($form);
        }
    });

    $('#contact-signup').click(function (e) { 
        e.preventDefault();
        
        var fname = $('#newsletter-fname').val();
        var lname = $('#newsletter-lname').val();
        var email = $('#newsletter-email').val();

        var form_fname = $('#mce-FNAME');
        var form_lname = $('#mce-LNAME');
        var form_email = $('#mce-EMAIL');

        var error = $('.newsletter-alert p');

        if (fname == "") {
            error.text('PLEASE FILL IN YOUR NAME')
            error.fadeIn(200);

        } else if (lname == "") {
            error.text('PLEASE FILL IN YOUR LAST NAME')
            error.fadeIn(200);

        } else if (email == "") {
            error.text('PLEASE FILL IN YOUR EMAIL')
            error.fadeIn(200);

        } else {
            form_fname.val(fname);
            form_lname.val(lname);
            form_email.val(email);


            register($form);
        }
    });

    $('#contact-page-signup').click(function (e) { 
        e.preventDefault();

        var form_fname = $('#mce-FNAME').val();
        var form_lname = $('#mce-LNAME').val();
        var form_email = $('#mce-EMAIL').val();

        var error = $('.newsletter-alert p');

        if (form_fname == "") {
            error.text('PLEASE FILL IN YOUR NAME')
            error.fadeIn(200);

        } else if (form_lname == "") {
            error.text('PLEASE FILL IN YOUR LAST NAME')
            error.fadeIn(200);

        } else if (form_email == "") {
            error.text('PLEASE FILL IN YOUR EMAIL')
            error.fadeIn(200);

        } else {
            register($form);
        }
    });

    function register($form) {

        var error = $('.newsletter-alert p');

        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            cache       : false,
            dataType    : 'json',
            contentType: "application/json; charset=utf-8",
            error       : function(err) { 
                error.text('SOMETHING WENT WRONG, PLEASE TRY AGAIN LATER')
                error.fadeIn(200);
            },
            success     : function(data) {
                if (data.result != "success") {
                    // Something went wrong, do something to notify the user.
                    console.log('Error: ' + data.msg);

                    if (data.msg.includes("is already subscribed")) {
                        error.text('THIS EMAIL IS ALREADY SUBSCRIBED')
                        error.fadeIn(200);
                    }

                    else if (data.msg.includes("must contain a single @")) {
                        error.text('EMAIL MUST CONTAIN A SINGLE @')
                        error.fadeIn(200);
                    }

                    else {
                        error.text('SOMETHING WENT WRONG, PLEASE TRY AGAIN LATER')
                        error.fadeIn(200);
                    }

                } else {
                    // It worked, carry on...
                    error.text('YOU HAVE BEEN SUCCESSFULLY SUBSCRIBED');
                    error.css("color", "#4caf50");
                    error.fadeIn(200);
                }
            }
        });
    }


    // More Address Stuff

    $('#use-default-address').click(function (e) { 
        
        var fname       = $('.defualt-fname').text();
        var lname       = $('.defualt-lname').text();
        var email       = $('.defualt-email').text();
        var address1    = $('.defualt-address1').text();
        var postcode    = $('.defualt-postcode').text();
        var city        = $('.defualt-city').text();
        var country     = $('.defualt-country').text();
        var phone       = $('.defualt-phone').text();

        var form_fname       = $('#user-name');
        var form_lname       = $('#user-surname');
        var form_email       = $('#user-email');
        var form_address1    = $('#user-address');
        var form_postcode    = $('#user-postcode');
        var form_city        = $('#user-city');
        var form_country     = $('#user-country');
        var form_phone       = $('#user-phone');

        

        if ($(this).is(":checked")) {

            form_fname.val(fname);
            form_lname.val(lname);   
            form_email.val(email); 
            form_address1.val(address1);
            form_postcode.val(postcode); 
            form_city.val(city); 
            form_country.val(country); 
            form_phone.val(phone); 

        } else {
            form_fname.val('');
            form_lname.val('');   
            form_email.val(''); 
            form_address1.val('');
            form_postcode.val(''); 
            form_city.val(''); 
            form_country.val(''); 
            form_phone.val(''); 
        }
        

    });


}); 